Mmg.addShortcode(

  /**
   * @param {string} shortcodeName The name of the shortcode
   * @param {string} selector The selector used to locate this shortcode in the DOM
   * @param {callable} callback The callback function applied to every element matching the selector
   */
  'stats_band',
  '.sc-stats-band',

  /**
   * Shortcode callback
   *
   * The shortcode callback receives the following parameters:
   *
   * @param {Element} el The shortcode's DOM element
   * @param {object} model The data model passed to the shortcode instance in data-json attribute
   * @param {jQuery} $ The callback function applied to every element matching the selector
   * @param {string} selector The shortcode selector that was passed to addShortcode
   * @param {string} className The name of the shortcode class
   */
  (el, model, $, selector, className) => {

  const $this = $(el);

  /**
   * Initialize the widget
   */
  (function init() {
    render();
    addEvents();
  })();

  /**
   * Bind event listeners
   */
  function addEvents() {
    $this.on('shown.bs.tab', render);
    $.breakpoint('change', render);
  }

  /**
   * Render all visible charts within the shortcode
   */
  function render() {
    $this.find(`${selector}__chart:visible`).each(renderChart);
  }

  /**
   * Initialise a chart on first render, or resize it on subsequent renders
   */
  function renderChart(index, $chart) {
    if ($chart.getAttribute('data-shown')) {
      echarts.getInstanceByDom($chart)?.resize();
      return;
    }

    const config = model.data[$chart.getAttribute('data-profession')]?.[$chart.getAttribute('data-chart-type')];
    if (!config) {
      return;
    }

    echarts.init($chart).setOption(config);
    $chart.setAttribute('data-shown', 'true');
  }
});
